import { SxProps, Theme } from '@mui/material'

export const containerSx: SxProps<Theme> = {
  backgroundColor: (theme) => theme.palette.background.paper,
}

export const contentGridSx: SxProps<Theme> = {
  maxWidth: {
    lg: '112rem',
    xl: '151.6rem',
  },
  margin: 'auto',
  padding: {
    xs: '2.4rem',
    md: '2.4rem 5.6rem 1.4rem',
    lg: 0,
  },
  columnGap: {
    lg: '4.8rem',
  },
}

export const findPerfectTechMatchLeftSideWrapperSx: SxProps<Theme> = {
  padding: {
    xs: 0,
    md: '2.4rem 0 1.6rem',
    lg: '8rem 0',
  },
  display: 'flex',
  alignItems: 'center',
  order: {
    xs: 1,
    lg: 'initial',
  },
}

export const findPerfectTechMatchLeftSideContentSx: SxProps<Theme> = {
  gap: {
    xs: '1.6rem',
    md: '2.4rem',
  },
}

export const findPerfectTechMatchRightSideWrapperSx: SxProps<Theme> = {
  height: {
    xs: 'auto',
    lg: '63.6rem',
  },
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  order: {
    xs: 2,
    lg: 'initial',
  },
  marginTop: {
    xs: '3rem',
    md: 0,
  },
  marginBottom: {
    xs: '0.9rem',
    md: 0,
  },
}

export const findPerfectTechMatchRightSideImageSx: SxProps<Theme> = {
  width: {
    xs: '100%',
    md: '72.2rem',
    lg: '53.2rem',
    xl: '73.4rem',
  },
  maxWidth: {
    md: '72.2rem',
    lg: '53.2rem',
    xl: '73.4rem',
  },
}

export const protectYourPrivacyAndControlLeftSideWrapperSx: SxProps<Theme> = {
  height: {
    xs: 'auto',
    lg: '77.2rem',
    xl: '75.2rem',
  },

  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  order: {
    xs: 5,
    lg: 'initial',
  },
  marginTop: {
    xs: '0.6rem',
    md: 0,
  },
  marginBottom: {
    xs: '1.2rem',
    md: 0,
  },
}

export const protectYourPrivacyAndControlLeftSideImageSx: SxProps<Theme> = {
  width: {
    xs: '100%',
    md: '72.2rem',
    lg: '53.2rem',
    xl: '73.4rem',
  },
  maxWidth: {
    md: '72.2rem',
    lg: '53.2rem',
    xl: '73.4rem',
  },
}

export const protectYourPrivacyAndControlRightSideWrapperSx: SxProps<Theme> = {
  padding: {
    xs: '2.4rem 0',
    md: '2.4rem 0 2.8rem',
    lg: '8rem 0',
  },
  paddingLeft: '2rem',
  display: 'flex',
  alignItems: 'center',
  order: {
    xs: 4,
    lg: 'initial',
  },
}

export const protectYourPrivacyAndControlRightSideContentSx: SxProps<Theme> = {
  gap: {
    xs: '1.6rem',
    md: '2.4rem',
  },
}

export const protectYourPrivacyAndControlTestimonialSx: SxProps<Theme> = {
  gap: {
    xs: '1.2rem',
    md: '1.8rem',
  },
}

export const saveTimeAndStreamlineYourEvaluationProcessLeftSideWrapperSx: SxProps<Theme> =
  {
    paddingRight: '1.5rem',
    padding: {
      xs: '2.4rem 0',
      lg: '8rem 0',
    },
    display: 'flex',
    alignItems: 'center',
    order: {
      xs: 7,
      lg: 'initial',
    },
  }

export const saveTimeAndStreamlineYourEvaluationProcessLeftSideContentSx: SxProps<Theme> =
  {
    gap: {
      xs: '1.6rem',
      md: '2.4rem',
    },
  }

export const saveTimeAndStreamlineYourEvaluationProcessTestimonialSx: SxProps<Theme> =
  {
    gap: '0.8rem',
    justifyContent: 'space-between',
  }

export const saveTimeAndStreamlineYourEvaluationProcessRightSideWrapperSx: SxProps<Theme> =
  {
    paddingBottom: {
      xs: '1.4rem',
      md: 0,
    },
    marginTop: {
      xs: '0.6rem',
      md: 0,
    },
    height: {
      xs: 'auto',
      lg: '52.8rem',
      xl: '62.4rem',
    },
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    order: {
      xs: 8,
      lg: 'initial',
    },
  }

export const saveTimeAndStreamlineYourEvaluationProcessRightSideImageSx: SxProps<Theme> =
  {
    width: {
      xs: '100%',
      md: '72.2rem',
      lg: '53.2rem',
      xl: '73.4rem',
    },
    maxWidth: {
      md: '72.2rem',
      lg: '53.2rem',
      xl: '73.4rem',
    },
  }

export const dividerWrapperSx: SxProps<Theme> = {
  padding: '0 !important',
  order: {
    xs: 3,
    lg: 'initial',
  },
  marginTop: {
    xs: '2.4rem',
    lg: 0,
  },
}

export const secondDividerWrapperSx: SxProps<Theme> = {
  padding: '0 !important',
  order: {
    xs: 6,
    lg: 'initial',
  },
  marginTop: {
    xs: '2.4rem',
    md: '3.2rem',
    lg: 0,
  },
}

export const titleSx: SxProps<Theme> = {
  color: (theme) => theme.palette.primary.main,
}
